'use client';

import { useCallback, useEffect, useRef, useState } from 'react';

export function useTextOverflow() {
  const textRef = useRef<HTMLDivElement>(null);
  const [hasOverflow, setHasOverflow] = useState(false);
  const [collapsedHeight, setCollapsedHeight] = useState<number | undefined>(undefined);
  const [expandedHeight, setExpandedHeight] = useState<number | undefined>(undefined);

  const checkOverflow = useCallback(() => {
    if (textRef.current) {
      const isOverflowing = textRef.current.scrollHeight > textRef.current.clientHeight;
      setHasOverflow(isOverflowing);

      if (isOverflowing) {
        setCollapsedHeight(textRef.current.clientHeight);
        setExpandedHeight(textRef.current.scrollHeight);
      }
    }
  }, []);

  useEffect(() => {
    const element = textRef.current;
    if (!element) {
      return;
    }

    checkOverflow();

    const observer = new ResizeObserver(checkOverflow);
    observer.observe(element);

    return () => observer.disconnect();
  }, [checkOverflow]);

  return { textRef, hasOverflow, collapsedHeight, expandedHeight };
}
